<template>
      <div id="summary-current">
            <section class="section summary-hero animate__animated animate__fadeIn">
                  <BackButton link="/one-more-question-current" />
                  <div class="grid-container max">
                        <div class="summary-hero-content">
                              <h1>Congratulations,<br />you&rsquo;re done.</h1>
                              <p class="summary-lead">Your plan will automatically roll over for 2027.</p>
                              <p class="summary-desc">Download a copy of the 2027 Open Enrollment Guide, which outlines the information presented in this interactive guide.</p>
                        </div>
                  </div>
                  <div class="summary-hero-btn-wrap">
                        <router-link to="/" class="summary-hero-btn" @click="track('CTA', 'Done - Summary Current')"><span>Done</span></router-link>
                        <a :href="planDownload" target="_blank" class="summary-hero-btn" @click="track('CTA', 'Download OE Guide - Summary Current')"><span>Download</span></a>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPSummaryCurrent",
            data (){
                  return{
                        planSelect: this.$store.state.planSelect,
                        getStartedURL:"https://myshbpga.adp.com/",
                        planDownload:"",
                  }
            },
            methods:{
                  download(){
                        let planSelect = this.planSelect
                        if(planSelect=="HMO") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Gold") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Silver") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Bronze") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else this.planDownload =  "/docs/OE-Guide-27.pdf"
                  }
            },
            beforeMount(){
                  this.download()
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#summary-current {
      .summary-hero {
            background-color: #1355E9;
            margin-top: 68px;
            padding: 120px 24px 140px 24px;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #ffffff;

                  &::before {
                        background-image: none;
                        background-color: #ffffff;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .summary-hero-content {
                  max-width: 760px;
                  margin: 0 auto;
                  text-align: center;

                  h1 {
                        color: #ffffff;
                        font-size: clamp(3rem, 6vw, 5.5rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 32px;
                  }

                  .summary-lead {
                        color: #ffffff;
                        font-size: 1.375rem;
                        font-weight: 500;
                        line-height: 1.4;
                        margin-bottom: 24px;
                  }

                  .summary-desc {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 1rem;
                        font-weight: 400;
                        line-height: 1.6;
                        margin-bottom: 0;
                  }
            }

            .summary-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  padding: 32px 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 24px;
            }

            .summary-hero-btn {
                  display: block;
                  background-color: #ffffff;
                  color: #1355E9 !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 280px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;

                  &:hover {
                        opacity: 0.85;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 40px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .summary-hero-content {
                        text-align: left;

                        h1 {
                              font-size: clamp(1.75rem, 9.5vw, 5.5rem) !important;
                        }
                  }

                  .summary-hero-btn-wrap {
                        position: static;
                        flex-direction: column;
                        gap: 16px;
                        padding: 40px 0 0 0;
                  }

                  .summary-hero-btn {
                        max-width: 100%;
                  }
            }
      }
}
</style>
